module.exports = __webpack_public_path__ + "img/Conduce2-64.c097e11a.png";